// pages/careers/Careers.js
import React, { useEffect, useState } from "react";
import DefaultLayout from "../../components/layout/DefaultLayout";
import {
  Row,
  Col,
  Button,
  Container,
  Table,
  Spinner,
  Modal,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCareersAction,
  fetchSingleCareerAction,
  deleteCareerAction,
} from "./CareerAction";
import { CareerForm } from "../../components/career/CareerForm";
import {
  selectCareers,
  selectSelectedCareer,
  selectIsLoading,
} from "./CareerSelectors";

const Careers = () => {
  const dispatch = useDispatch();

  const careers = useSelector(selectCareers);
  const selectedCareer = useSelector(selectSelectedCareer);
  const isLoading = useSelector(selectIsLoading);

  const [showForm, setShowForm] = useState(false);
  const [editCareerId, setEditCareerId] = useState(null);
  const [editInitial, setEditInitial] = useState(null);

  useEffect(() => {
    dispatch(fetchCareersAction());
  }, [dispatch]);

  const handleEdit = (id) => {
    setEditCareerId(id);
    const existing = Array.isArray(careers)
      ? careers.find((c) => c._id === id)
      : null;
    setEditInitial(existing || null);
    dispatch(fetchSingleCareerAction(id)); // refresh in background
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this career?")) {
      await dispatch(deleteCareerAction(id));
      dispatch(fetchCareersAction()); // refresh list
    }
  };

  const handleAddNew = () => {
    setEditCareerId(null);
    setEditInitial(null);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditCareerId(null);
    setEditInitial(null);
  };

  return (
    <DefaultLayout>
      <Container>
        <Row className="py-2">
          <Col>
            <h5>Careers</h5>
            <div className="text-end">
              <Button variant="primary" onClick={handleAddNew}>
                Add New Career
              </Button>
            </div>
            <hr />
          </Col>
        </Row>

        {isLoading && (
          <div className="text-center py-3">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        <Row>
          <Col>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Location</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Company</th>
                  <th>Created On</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(careers) && careers.length > 0 ? (
                  careers.map((c) => (
                    <tr key={c._id}>
                      <td>{c.title}</td>
                      <td>{c.location}</td>
                      <td>{c.employmentType}</td>
                      <td>{c.status}</td>
                      <td>{c.company?.name ?? "N/A"}</td>
                      <td>
                        {c.createdAt
                          ? new Date(c.createdAt).toLocaleDateString()
                          : "-"}
                      </td>
                      <td>
                        <Button
                          variant="warning"
                          size="sm"
                          className="me-2"
                          onClick={() => handleEdit(c._id)}
                        >
                          Edit
                        </Button>

                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleDelete(c._id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      No careers found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* Add / Edit Modal */}
        <Modal show={showForm} onHide={handleCloseForm} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              {editCareerId ? "Edit Career" : "Add New Career"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CareerForm
              careerId={editCareerId}
              initialData={editInitial}
              selectedCareer={selectedCareer}
              onClose={() => {
                handleCloseForm();
                dispatch(fetchCareersAction());
              }}
            />
          </Modal.Body>
        </Modal>
      </Container>
    </DefaultLayout>
  );
};

export default Careers;
